import tw, { styled } from 'twin.macro';
import Link from '@/components/Link/Link';

export const StyledEditionsDownloadContainer = styled.section`
  ${tw`flex justify-center flex-col items-center`}
  ${tw`bg-ui-colours-ui1`}
`;

export const StyledEditionsDownloadBlock = styled.div`
  ${tw`flex flex-col lg:flex-row`}
  ${tw`w-[calc(100% - 32px)] lg:w-[unset]`}
  ${tw`rounded-lg`}
  ${tw`bg-neutrals-n1`}
`;

export const StyledEditionsDownloadVersionTitle = styled.p`
  ${tw`font-inter`}
  ${tw`text-body-m text-neutrals-n8`}
  ${tw`mb-2`}
`;

export const StyledBottomLinksContainer = styled.div`
  ${tw`mt-5 mx-2`}
  ${tw`text-center`}
`;

export const StyledBottomLink = styled(Link)`
  ${tw`relative`}
  ${tw`inline`}
  ${tw`[letter-spacing: normal]`}
  ${tw`whitespace-normal`}
  ${tw`lg:hover:underline`}
  ${tw`lg:not-first-of-type:pl-2`}
  ${tw`lg:not-last:pr-2`}

  ${tw`after:[content:unset]`}
  ${tw`hover:after:[content:unset]`}

  ${tw`lg:not-last:after:absolute lg:not-last:after:right-0`}

  ${tw`not-last:after:content-['_|_']`}
  ${tw`not-last:after:text-primary-p1`}
`;
